"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _css2 = _interopRequireDefault(require("@emotion/css"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Flex = _interopRequireDefault(require("../../Flex"));

var _SeparatorsContainer = _interopRequireDefault(require("../../SeparatorsContainer"));

var _useTheme2 = _interopRequireDefault(require("../../styles/useTheme"));

var _JobPeriod = _interopRequireDefault(require("./Dates/JobPeriod"));

var _Location = _interopRequireDefault(require("./Location"));

var _WeeklyHours = _interopRequireDefault(require("./WeeklyHours"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var _ref = process.env.NODE_ENV === "production" ? {
  name: "qn2iez-Main",
  styles: "box-sizing:border-box;;label:Main;"
} : {
  name: "qn2iez-Main",
  styles: "box-sizing:border-box;;label:Main;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9SZXNwb25zaXZlSm9iQ2FyZC9NYWluL2luZGV4LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUF3Qk0iLCJmaWxlIjoiLi4vLi4vLi4vc3JjL1Jlc3BvbnNpdmVKb2JDYXJkL01haW4vaW5kZXgudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IEZ1bmN0aW9uQ29tcG9uZW50IH0gZnJvbSAncmVhY3QnO1xuXG5pbXBvcnQgRmxleCwgeyBGbGV4UHJvcHMgfSBmcm9tICcuLi8uLi9GbGV4JztcbmltcG9ydCBTZXBhcmF0b3JzQ29udGFpbmVyIGZyb20gJy4uLy4uL1NlcGFyYXRvcnNDb250YWluZXInO1xuaW1wb3J0IHVzZVRoZW1lIGZyb20gJy4uLy4uL3N0eWxlcy91c2VUaGVtZSc7XG5pbXBvcnQgSm9iUGVyaW9kIGZyb20gJy4vRGF0ZXMvSm9iUGVyaW9kJztcbmltcG9ydCBMb2NhdGlvbiBmcm9tICcuL0xvY2F0aW9uJztcbmltcG9ydCBXZWVrbHlIb3VycyBmcm9tICcuL1dlZWtseUhvdXJzJztcblxuZXhwb3J0IGludGVyZmFjZSBNYWluUHJvcHMgZXh0ZW5kcyBGbGV4UHJvcHM8J2Rpdic+IHtcbiAgc3RhcnREYXRlPzogc3RyaW5nIHwgbnVtYmVyO1xuICBlbmREYXRlPzogc3RyaW5nIHwgbnVtYmVyO1xuICB3ZWVrbHlIb3Vycz86IG51bWJlcjtcbiAgY2l0eU5hbWU/OiBzdHJpbmc7XG4gIHBvc3RhbENvZGU/OiBzdHJpbmc7XG59XG5cbmNvbnN0IE1haW46IEZ1bmN0aW9uQ29tcG9uZW50PE1haW5Qcm9wcz4gPSAocHJvcHMpID0+IHtcbiAgY29uc3QgeyBzdGFydERhdGUsIGVuZERhdGUsIHdlZWtseUhvdXJzLCBjaXR5TmFtZSwgcG9zdGFsQ29kZSwgLi4ub3RoZXIgfSA9IHByb3BzO1xuXG4gIGNvbnN0IHsgc3BhY2luZyB9ID0gdXNlVGhlbWUoKTtcblxuICByZXR1cm4gKFxuICAgIDxGbGV4XG4gICAgICBjc3M9e3sgYm94U2l6aW5nOiAnYm9yZGVyLWJveCcgfX1cbiAgICAgIGZsZXhEaXJlY3Rpb249XCJjb2x1bW5cIlxuICAgICAgcGFkZGluZz17WzAsIDJdfVxuICAgICAgbWFyZ2luPXtbLTEuNSwgMF19XG4gICAgICB3aWR0aD1cIjEwMCVcIlxuICAgICAgey4uLm90aGVyfVxuICAgID5cbiAgICAgIDxTZXBhcmF0b3JzQ29udGFpbmVyIGNzcz17eyBtYXJnaW46IHNwYWNpbmcoMCwgLTQpIH19PlxuICAgICAgICA8TG9jYXRpb24gY2l0eU5hbWU9e2NpdHlOYW1lfSBwb3N0YWxDb2RlPXtwb3N0YWxDb2RlfSAvPlxuICAgICAgICA8Sm9iUGVyaW9kIHN0YXJ0RGF0ZT17c3RhcnREYXRlfSBlbmREYXRlPXtlbmREYXRlfSAvPlxuICAgICAgICA8V2Vla2x5SG91cnMgd2Vla2x5SG91cnM9e3dlZWtseUhvdXJzfSAvPlxuICAgICAgPC9TZXBhcmF0b3JzQ29udGFpbmVyPlxuICAgIDwvRmxleD5cbiAgKTtcbn07XG5cbmV4cG9ydCBkZWZhdWx0IE1haW47XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var Main = function Main(props) {
  var startDate = props.startDate,
      endDate = props.endDate,
      weeklyHours = props.weeklyHours,
      cityName = props.cityName,
      postalCode = props.postalCode,
      other = (0, _objectWithoutProperties2["default"])(props, ["startDate", "endDate", "weeklyHours", "cityName", "postalCode"]);

  var _useTheme = (0, _useTheme2["default"])(),
      spacing = _useTheme.spacing;

  return (0, _core.jsx)(_Flex["default"], (0, _extends2["default"])({
    css: _ref,
    flexDirection: "column",
    padding: [0, 2],
    margin: [-1.5, 0],
    width: "100%"
  }, other), (0, _core.jsx)(_SeparatorsContainer["default"], {
    css: /*#__PURE__*/(0, _css2["default"])({
      margin: spacing(0, -4)
    }, ";label:Main;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9SZXNwb25zaXZlSm9iQ2FyZC9NYWluL2luZGV4LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUErQjJCIiwiZmlsZSI6Ii4uLy4uLy4uL3NyYy9SZXNwb25zaXZlSm9iQ2FyZC9NYWluL2luZGV4LnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCwgeyBGdW5jdGlvbkNvbXBvbmVudCB9IGZyb20gJ3JlYWN0JztcblxuaW1wb3J0IEZsZXgsIHsgRmxleFByb3BzIH0gZnJvbSAnLi4vLi4vRmxleCc7XG5pbXBvcnQgU2VwYXJhdG9yc0NvbnRhaW5lciBmcm9tICcuLi8uLi9TZXBhcmF0b3JzQ29udGFpbmVyJztcbmltcG9ydCB1c2VUaGVtZSBmcm9tICcuLi8uLi9zdHlsZXMvdXNlVGhlbWUnO1xuaW1wb3J0IEpvYlBlcmlvZCBmcm9tICcuL0RhdGVzL0pvYlBlcmlvZCc7XG5pbXBvcnQgTG9jYXRpb24gZnJvbSAnLi9Mb2NhdGlvbic7XG5pbXBvcnQgV2Vla2x5SG91cnMgZnJvbSAnLi9XZWVrbHlIb3Vycyc7XG5cbmV4cG9ydCBpbnRlcmZhY2UgTWFpblByb3BzIGV4dGVuZHMgRmxleFByb3BzPCdkaXYnPiB7XG4gIHN0YXJ0RGF0ZT86IHN0cmluZyB8IG51bWJlcjtcbiAgZW5kRGF0ZT86IHN0cmluZyB8IG51bWJlcjtcbiAgd2Vla2x5SG91cnM/OiBudW1iZXI7XG4gIGNpdHlOYW1lPzogc3RyaW5nO1xuICBwb3N0YWxDb2RlPzogc3RyaW5nO1xufVxuXG5jb25zdCBNYWluOiBGdW5jdGlvbkNvbXBvbmVudDxNYWluUHJvcHM+ID0gKHByb3BzKSA9PiB7XG4gIGNvbnN0IHsgc3RhcnREYXRlLCBlbmREYXRlLCB3ZWVrbHlIb3VycywgY2l0eU5hbWUsIHBvc3RhbENvZGUsIC4uLm90aGVyIH0gPSBwcm9wcztcblxuICBjb25zdCB7IHNwYWNpbmcgfSA9IHVzZVRoZW1lKCk7XG5cbiAgcmV0dXJuIChcbiAgICA8RmxleFxuICAgICAgY3NzPXt7IGJveFNpemluZzogJ2JvcmRlci1ib3gnIH19XG4gICAgICBmbGV4RGlyZWN0aW9uPVwiY29sdW1uXCJcbiAgICAgIHBhZGRpbmc9e1swLCAyXX1cbiAgICAgIG1hcmdpbj17Wy0xLjUsIDBdfVxuICAgICAgd2lkdGg9XCIxMDAlXCJcbiAgICAgIHsuLi5vdGhlcn1cbiAgICA+XG4gICAgICA8U2VwYXJhdG9yc0NvbnRhaW5lciBjc3M9e3sgbWFyZ2luOiBzcGFjaW5nKDAsIC00KSB9fT5cbiAgICAgICAgPExvY2F0aW9uIGNpdHlOYW1lPXtjaXR5TmFtZX0gcG9zdGFsQ29kZT17cG9zdGFsQ29kZX0gLz5cbiAgICAgICAgPEpvYlBlcmlvZCBzdGFydERhdGU9e3N0YXJ0RGF0ZX0gZW5kRGF0ZT17ZW5kRGF0ZX0gLz5cbiAgICAgICAgPFdlZWtseUhvdXJzIHdlZWtseUhvdXJzPXt3ZWVrbHlIb3Vyc30gLz5cbiAgICAgIDwvU2VwYXJhdG9yc0NvbnRhaW5lcj5cbiAgICA8L0ZsZXg+XG4gICk7XG59O1xuXG5leHBvcnQgZGVmYXVsdCBNYWluO1xuIl19 */"))
  }, (0, _core.jsx)(_Location["default"], {
    cityName: cityName,
    postalCode: postalCode
  }), (0, _core.jsx)(_JobPeriod["default"], {
    startDate: startDate,
    endDate: endDate
  }), (0, _core.jsx)(_WeeklyHours["default"], {
    weeklyHours: weeklyHours
  })));
};

__signature__(Main, "useTheme{{ spacing }}", function () {
  return [_useTheme2["default"]];
});

var _default = Main;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Main, "Main", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/Main/index.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/Main/index.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();